import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Home/Home';
import Booking from './Booking/Booking';
import CabDetails from './CabDetails/CabDetails';
import Navber from '../../Components/Navber';

const CabBookingRoutes = () => (
  <>
    <Navber />
    <Routes>
      <Route index element={<Home />} />
      <Route path="book" element={<Booking />} />
      <Route path="cab-details" element={<CabDetails />} />
    </Routes>
  </>
);

export default CabBookingRoutes;